/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateProtocolSessionDto
 */
export interface CreateProtocolSessionDto {

    /**
     * @type {JoinEntityDto}
     * @memberof CreateProtocolSessionDto
     */
    session: JoinEntityDto;

    /**
     * @type {number}
     * @memberof CreateProtocolSessionDto
     */
    order?: number;
}
